import type { ComputedRef, MaybeRefOrGetter } from 'vue';

export const PROVISIONAL_PLATE_SUPPORTED_COUNTRIES = ['IT', 'ES'] as const;

export type ProvisionalPlateCountry = (typeof PROVISIONAL_PLATE_SUPPORTED_COUNTRIES)[number];

export type UseProvisionalLicensePlateLocaleReturn = {
    provisionalPlateCountry: ComputedRef<ProvisionalPlateCountry | null>;
    title: ComputedRef<string | undefined>;
    subtitle: ComputedRef<string | undefined>;
    tooltipText: ComputedRef<string | undefined>;
};

const isProvisionalPlateCountry = (c: string): c is ProvisionalPlateCountry =>
    PROVISIONAL_PLATE_SUPPORTED_COUNTRIES.includes(c as ProvisionalPlateCountry);

export const useProvisionalLicensePlateLocale = (country: MaybeRefOrGetter<string>): UseProvisionalLicensePlateLocaleReturn => {
    const { tt } = useTypedI18n();

    const provisionalPlateCountry = computed<ProvisionalPlateCountry | null>(() => {
        const c = toValue(country).toUpperCase();

        return isProvisionalPlateCountry(c) ? c : null;
    });

    const title = computed<string | undefined>(() =>
        provisionalPlateCountry.value ? tt(`vas.ProvisionalLicensePlate.byAssetCountry.${provisionalPlateCountry.value}.title`) : undefined
    );

    const subtitle = computed<string | undefined>(() =>
        provisionalPlateCountry.value ? tt(`vas.ProvisionalLicensePlate.byAssetCountry.${provisionalPlateCountry.value}.subtitle`) : undefined
    );

    const tooltipText = computed<string | undefined>(() =>
        provisionalPlateCountry.value ? tt(`vas.ProvisionalLicensePlate.byAssetCountry.${provisionalPlateCountry.value}.tooltip`) : undefined
    );

    return { provisionalPlateCountry, title, subtitle, tooltipText };
};
